import { Outlet } from 'react-router-dom';
import { BottomTabBar } from './BottomTabBar';

export function MobileLayout() {
    return (
        <div
            className="w-full bg-background flex flex-col overflow-hidden"
            style={{ minHeight: '100dvh', height: '100dvh' }}
        >
            {/* Main content area */}
            <main className="flex-1 overflow-y-auto overflow-x-hidden">
                <Outlet />
            </main>

            {/* Bottom navigation */}
            <BottomTabBar />
        </div>
    );
}
